import { CloudFunctions } from '@telespot/sdk';
import { type IAddUserHandler, AffiliateInfo, AddUser } from '@telespot/authentication/use-cases';

export class ParseAddUserHandler implements IAddUserHandler {
  public async execute(command: AddUser): Promise<AffiliateInfo> {
    return CloudFunctions.AddUser({
      emailOrUsername: command.details.emailOrUsername,
      organizationId: command.details.organizationId,
      password: command.details.password,
    });
  }
}
